import React, { Component } from 'react'
import { string, bool, func } from 'prop-types'
import { Icon } from 'components'

export class McGameListCheckbox extends Component {
    static proptTypes = {
        label: string.isRequired,
        text: string,
        value: bool,
        onChange: func.isRequired,
    }
    static defaultProps = {
        value: false,
        text: undefined,
    }

    handleToggle = () => {
        const { value, onChange } = this.props
        onChange(!value)
    }

    render() {
        const { label, text, value } = this.props
        return (
            <div className="McGameList-FormGroup FG-Checkbox">
                <div className="McGameList-FormGroup-Label">{label}&nbsp;</div>
                <div className="McGameList-FormGroup-InputWrapper" onClick={this.handleToggle}>
                    <Icon name={value ? 'checkbox-checked' : 'checkbox-unchecked'} />
                    <div className="McGameList-FormGroup-CheckboxText">{text}</div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/GameList/Filters/McGameListCheckbox.js